export default {
  loadMainApiData({ dispatch }) {
    dispatch('Coordinates/initCoordinates')
  }
}
